/**
 * Chip que mostra o tenant ativo no topbar do admin — TH-54656.
 *
 * Aparece apenas quando user.role === 'super_admin' E há tenant
 * selecionado. Para os demais roles, o tenant vem do JWT — não tem
 * porque expor o chip nem o botão "trocar". Clicar em "trocar" limpa
 * a seleção e navega para /select-tenant.
 *
 * Visual: paridade com o protótipo (chip dourado discreto com nome
 * truncado), botão fantasma à direita. Mobile espelha o mesmo padrão
 * (`provideTenantInterceptor` + seletor no PostLoginRouter).
 */

import { Link } from "@tanstack/react-router";
import { Building2 } from "lucide-react";

import { useAuth } from "@/hooks/useAuth";
import { useTenantSelectionStore } from "@/stores/tenantSelectionStore";

export function TenantChip() {
  const { user } = useAuth();
  const selection = useTenantSelectionStore((s) => s.selection);

  if (user?.role !== "super_admin" || !selection) {
    return null;
  }

  return (
    <div className="flex items-center gap-2">
      <span
        className="hidden items-center gap-1.5 rounded-full bg-[var(--color-primary-soft)] px-2.5 py-1 sm:flex"
        data-testid="tenant-chip"
        title={`Tenant ativo: ${selection.name}`}
      >
        <Building2
          aria-hidden
          className="h-3.5 w-3.5 text-[var(--color-primary)]"
        />
        <span className="max-w-[160px] truncate font-mono text-[11px] uppercase tracking-[0.05em] text-[var(--color-primary)]">
          {selection.name}
        </span>
      </span>
      <Link
        to="/select-tenant"
        className="rounded-md px-2 py-1 text-[11px] font-medium uppercase tracking-[0.05em] text-[var(--color-muted-foreground)] transition-colors hover:bg-[var(--color-secondary)] hover:text-[var(--color-foreground)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-ring)]"
        data-testid="tenant-chip-switch"
      >
        Trocar
      </Link>
    </div>
  );
}
